// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";
import { authReducer } from "./auth";
import ensuredGoods from "@src/views/Catalogs/EnsuredGoods/store";
import accountants from "@src/views/Users/Accountants/store";
import excludedGoods from "@src/views/Catalogs/ExcludedGoods/store";
import modesTransport from "@src/views/Catalogs/ModesTransport/store";
import taxData from "@src/views/Users/BusinessNames/store";
import providers from "@src/views/Catalogs/Clauses/store";
import validities from "@src/views/Catalogs/Validities/store";
import electronicEquipments from "@src/views/Catalogs/ElectronicEquipment/store";
import projectProfiles from "@src/views/Catalogs/ProjectProfile/store";
import providersCatalog from "@src/views/Catalogs/Providers/store";
import coverage from "@src/views/Catalogs/Coverage/store";
import sellers from "@src/views/Users/Sellers/store";
import clients from "@src/views/Users/Clients/store";
import prospects from "@src/views/Prospects/store";
import admins from "@src/views/Users/Admins/store";
import concepts from "@src/views/Catalogs/Concepts/store";
import countries from "@src/views/Catalogs/Countries/store";
import wizard from "@src/views/Certs/store";
import maps from "./maps";
// import cert from "./certificate"
import response from "./response";
import filters from "./filters";
import modalTypeDelete from "./modalTypeDelete";
import modalTypeSuccess from "./modalTypeSuccess";
import modalTypeError from "./modalTypeError";
import modalTypeEdit from "./modalTypeEdit";
import modalTypeCustom from "./modalTypeCustom";
import modalTypeFullCustom from "./modalTypeFullCustom";
import modalTypeRenew from "./modalTypeRenew";
import modalTypeCertRenewalOptions from "./modalTypeCertRenewalOptions";
import modalEditCertUpload from "./modalEditCertUpload";
import address from "./address";
import destination from "./destination";
import fiscal from "./fiscal";
import certificate from "@src/views/Certs/store/certs";
import sellerList from "@src/views/Certs/store/sellers";
import clientList from "@src/views/Certs/store/clients";
import beneficiariesList from "@src/views/Certs/store/beneficiaries";
import taxdataList from "@src/views/Certs/store/taxdata";
import invoices from "@src/views/Invoices/store/invoices";
import { paymentsReducer } from "./payments";
import { transactionsReducer } from "./transactions";
import commissions from "@src/views/Commissions/store";
import refunds from "@src/views/Commissions/store/refunds";
import history from "@src/views/Commissions/store/history";
// Dashboard
import dashboardFilters from "@src/views/Dashboards/store";
// Quotations
import quotations from "@src/views/Quotations/store";
import cancellations from "@src/views/Cancellations/store";
import modalSessionExpired from "./modalSessionExpired";
import modalWelcome from "./modalWelcome";
import modalClientActivation from "./modalClientActivation";
//Clients and Prospects
import modalLinkProspectAtClient from "./modalLinkProspectAtClient";
// Balances
import balances from "@src/views/Balances/store";
import balance_summary from "@src/views/Balances/store/balance_summary";
import products from "./products";
import plans from "@src/views/Catalogs/Plans/store";
import schoolingLevels from "@src/views/Catalogs/SchoolingLevels/store";
import blocks from "./blocks";
// Notifications
import notifications from "@src/views/Configuration/Notifications/store/notifications";
import contractValues from "@src/views/Catalogs/ContractValues/store";
import coveragesRC from "@src/views/Catalogs/CoveragesRC/store";
import insuredSumValues from "@src/views/Catalogs/InsuredSumValues/store";
import projects from "@src/views/Projects/store";
import rcClients from "@src/views/RCClients/store";
import rcContractors from "@src/views/RCContractors/store";
import externalContractor from "@src/views/RCContractors/publicStore";
import companies from "@src/views/Companies/store";
import documentation from "@src/views/Documentation/store";
import typeProjects from "@src/views/TypeProjects/store";
import contractorDashboard from "../views/Dashboards/Contractor/store";
import businessDashboard from "../views/Dashboards/Business/store";
import o360Groups from "@src/views/Certs/store/o360-groups";
import o360Memberships from "@src/views/Certs/store/o360-memberships";
import o360Coverages from "@src/views/Certs/store/o360-coverages";
import apSchoolGroups from "@src/views/Certs/store/ap-school-groups";
import apSchoolCoverages from "@src/views/Certs/store/ap-school-coverages";
import employeeBeneficiaries from "@src/views/employee-beneficiaries/store";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { combineReducers } from "redux";
import { bankCardsReducer } from "./bank-cards";
import { modalConfirmReducer } from "./modals/modal-confirm";
import { paymentReferencesReducer } from "./payment-references";
import businessLines from "./businessLines";
import { sellerClientsReducer } from "./seller-clients";
import { generalSuggestionsReducer } from "@src/@core/layouts/components/navbar/general-searcher/slice";
import { clientsEmployeesReducer } from "@src/views/upload-employees/store";
import { clientsStudentsReducer } from "@src/views/upload-students/store";

const reducers = {
  accountants,
  address,
  admins,
  auth: authReducer,
  balance_summary,
  balances,
  bankCards: bankCardsReducer,
  cancellations,
  certificate,
  clientList,
  beneficiariesList,
  clients,
  prospects,
  commissions,
  concepts,
  contractValues,
  contractorDashboard,
  businessDashboard,
  coveragesRC,
  countries,
  coverage,
  projects,
  rcClients,
  rcContractors,
  externalContractor,
  companies,
  documentation,
  typeProjects,
  dashboardFilters,
  destination,
  electronicEquipments,
  employeeBeneficiaries,
  ensuredGoods,
  excludedGoods,
  insuredSumValues,
  filters,
  fiscal,
  history,
  invoices,
  layout,
  maps,
  modalClientActivation,
  modalLinkProspectAtClient,
  modalConfirm: modalConfirmReducer,
  modalEditCertUpload,
  modalSessionExpired,
  modalTypeCustom,
  modalTypeDelete,
  modalTypeEdit,
  modalTypeError,
  modalTypeFullCustom,
  modalTypeRenew,
  modalTypeCertRenewalOptions,
  modalTypeSuccess,
  modalWelcome,
  modesTransport,
  navbar,
  notifications,
  o360Groups,
  o360Coverages,
  o360Memberships,
  apSchoolGroups,
  apSchoolCoverages,
  paymentReferences: paymentReferencesReducer,
  payments: paymentsReducer,
  transactions: transactionsReducer,
  plans,
  schoolingLevels,
  projectProfiles,
  providers,
  providersCatalog,
  quotations,
  refunds,
  response,
  sellerClients: sellerClientsReducer,
  clientsEmployees: clientsEmployeesReducer,
  clientsStudents: clientsStudentsReducer,
  sellerList,
  sellers,
  taxData,
  taxdataList,
  validities,
  wizard,
  ["general-suggestions"]: generalSuggestionsReducer
};

const rootReducer = combineReducers({
  businessLines: persistReducer(
    {
      key: "businessLines",
      storage
    },
    businessLines
  ),
  products: persistReducer(
    {
      key: "products",
      storage
    },
    products
  ),
  blocks: persistReducer(
    {
      key: "blocks",
      storage
    },
    blocks
  ),
  ...reducers
});

export default rootReducer;
